import { Component, OnInit, EventEmitter, Output } from '@angular/core';
import { FormBuilder, FormGroup, ValidationErrors, Validators, AbstractControl, FormControl } from '@angular/forms';
import { HttpService } from '../../shared/services/http.service';
import { CustomTranslatorService } from '../../shared/services/custom.translator.service';
import { DynamicDialogConfig } from 'primeng/dynamicdialog';

@Component({
    selector: 'tde-change-password',
    templateUrl: './change-password.component.html',
    styleUrls: ['./change-password.component.scss'],
    standalone: false
})
export class ChangePasswordComponent {
  @Output() onClose: EventEmitter<Record<string, object>> = new EventEmitter();
  public changePasswordForm: FormGroup;
  public userFormEnable: boolean = false;
  constructor(
    private formBuilder: FormBuilder,
    private httpService: HttpService,
    public config: DynamicDialogConfig,    
    private _customTranslateService: CustomTranslatorService,
  ) { }

  // confirm new password validator
  private passwordMatcher(control: FormControl): { [s: string]: boolean } {
    if (
      this.changePasswordForm &&
      (control.value !== this.changePasswordForm.controls.newPassword.value)
    ) {
      return { passwordNotMatch: true };
    }
    return null;
  }

  ngOnInit(): void {
    this.changePasswordForm = this.formBuilder.group({
      currentPassword: ['', [Validators.required]],
      newPassword: ['', [Validators.required, Validators.minLength(8), Validators.maxLength(20)]],
      newConfirmPassword: [null, [Validators.required, Validators.minLength(8), Validators.maxLength(20),
      this.passwordMatcher.bind(this)]],
    });
  }

  ngAfterViewInit() {
    this.userFormEnable = true;
  }

   // Ensure initComponent is defined in the component it's being called on
   initComponent(data): void {
    this.config.data = data;
  }


  onSubmit() {
    if (this.changePasswordForm.value.newPassword !== this.changePasswordForm.value.newConfirmPassword) {
      this.changePasswordForm.controls.newConfirmPassword.setErrors({ passwordNotMatch: true });
    }
    else {
      this.changePasswordForm.controls.newConfirmPassword.setErrors(null);
    }
    if (this.changePasswordForm.invalid) {
      this.changePasswordForm.markAllAsTouched();
    }
    else {
      if (this.changePasswordForm.value.newPassword === this.changePasswordForm.value.currentPassword) {
        this._customTranslateService.showTranslatedNotification('CHANGE_PWS__PWS_NOT_MATCH', 'error');
      }
      else {
        const payload = {
          currentPassword: btoa(this.changePasswordForm.value.currentPassword),
          newPassword: btoa(this.changePasswordForm.value.newPassword)
        };
        this.httpService.post('users/change-password', payload).subscribe(data => {
          if (data.actionStatus === 'SUCCESS') {
            this._customTranslateService.showTranslatedNotification('CHANGE_PWS__UPD_SUCC', 'success');
            this.changePasswordForm.reset();
          }
        });
      }
    }
  }

  resetForm() {
    this.changePasswordForm.reset(); // Resets the form to its initial state
  }

  cancel() {
    this.onClose.emit({});
  }
}
